import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { ToggleCard, SelectLabel, Button } from '@weezevent/nacre';
import Styles from '../resaleSettings.module.css';
import { getTemplateOptions } from '../utils';

function ToggleCardTemplate({ toggleTitle, toggleSubtitle, toggleValue = true, templateValue, onTemplateChange, onToggleChange, templates, loading }) {
    const { t } = useTranslation();

    const templateOptions = React.useMemo(() => {
        return getTemplateOptions(templates, t);
    }, [templates]);

    const selectedTemplate = templates.find(t => t.id === templateValue);

    const handlePreview = () => {
        if (selectedTemplate?.preview_url) {
            window.open(selectedTemplate.preview_url, '_blank');
        }
    };

    return (
        <ToggleCard title={toggleTitle} subtitle={toggleSubtitle} toggle={toggleValue} onToggle={onToggleChange} className={Styles['notification-toggle-template']}>
            <div className={Styles['notification-toggle-template__active-section']}>
                <SelectLabel
                    label={t('ticket.resales.settings.notifications.email_template')}
                    placeholder={t('ticket.resales.settings.notifications.email_template_placeholder')}
                    options={templateOptions}
                    value={templateValue}
                    onChange={value => onTemplateChange(value)}
                    loading={loading}
                    disabled={loading}
                    clearable
                />
            </div>
            <Button primary inverted label={t('ticket.resales.settings.notifications.preview')} onClick={handlePreview} />
        </ToggleCard>
    );
}

ToggleCardTemplate.propTypes = {
    toggleTitle: PropTypes.string.isRequired,
    toggleSubtitle: PropTypes.string.isRequired,
    toggleValue: PropTypes.bool.isRequired,
    onToggleChange: PropTypes.func.isRequired,
    templateValue: PropTypes.number,
    onTemplateChange: PropTypes.func.isRequired,
    templates: PropTypes.array.isRequired,
    loading: PropTypes.bool
};

export default ToggleCardTemplate;
